<template>
    <div class="rental-process rental-out section section--floating">
        <h2 class="rental-process__heading section__heading">
            {{ $t('sections.rental_out_process.heading') }}
        </h2>

        <ol class="rental-process__items wrap">
            <li class="process-item">
                <svg-icon name="application" class="process-item__icon" />
                <h3 class="process-item__heading">
                    {{ $t('sections.rental_out_process.step_1_heading') }}
                </h3>
                <p class="process-item__text">
                    {{ $t('sections.rental_out_process.step_1_text') }}
                </p>
            </li>
            <li class="process-item">
                <svg-icon name="mobile-phone" class="process-item__icon" />
                <h3 class="process-item__heading">
                    {{ $t('sections.rental_out_process.step_2_heading') }}
                </h3>
                <p class="process-item__text">
                    {{ $t('sections.rental_out_process.step_2_text') }}
                </p>
            </li>
            <li class="process-item">
                <svg-icon name="coffee" class="process-item__icon" />
                <h3 class="process-item__heading">
                    {{ $t('sections.rental_out_process.step_3_heading') }}
                </h3>
                <p class="process-item__text">
                    {{ $t('sections.rental_out_process.step_3_text') }}
                </p>
            </li>
        </ol>
        <div v-if="!isLoggedIn" class="section__buttons wrap">
            <ModalLink to="sign-up" class="button button--primary">
                {{ $t('sections.rental_out_process.signtup_button') }}
            </ModalLink>
        </div>
        <div v-if="isLoggedIn && isOwner" class="section__buttons wrap">
            <LocalizedLink :to="{ name: 'owner-publish-vehicle' }" class="hero__button button button--primary">
                {{ $t('pages.rent_out.start_renting_out') }}
            </LocalizedLink>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalLink from '~/components/modals/ModalLink.vue';

export default {
    components: { ModalLink },
    computed: {
        ...mapGetters(['isLoggedIn', 'isOwner']),
    },
};
</script>
